import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import s from './Tooltip.scss';

export interface Props {
  hasJoinedWithEclipse?: boolean;
}

const Tooltip: React.SFC<Props & WithTranslation> = ({
  hasJoinedWithEclipse,
  t,
}: Props & WithTranslation) => {
  if (hasJoinedWithEclipse) {
    return (
      <div className={s['edit-tooltip']}>
        <h5 className={s['edit-tooltip-header']}>
          {t('widgets.aboutMe.edit.tooltip.newuser.title')}
        </h5>
        <p>{t('widgets.aboutMe.edit.tooltip.newuser.message')}</p>
      </div>
    );
  }
  return (
    <div className={s['edit-tooltip']}>
      <h5 className={s['edit-tooltip-header']}>
        {t('widgets.aboutMe.edit.tooltip.existinguser.title')}
      </h5>
      <p>{t('widgets.aboutMe.edit.tooltip.existinguser.message')}</p>
    </div>
  );
};

export default withTranslation()(Tooltip);
